import { Pedido } from "./pedido";

export interface Order {
  status: string;
  data: Pedido[];
}

export interface QuantidadePedidos {
  Consumo: number;
  Entrega: number;
  Pedidos: number;
  Retirada: number;
}

export enum OpcaoEntrega {
  ENTREGA = "E",
  RETIRADA = "R",
  CONSUMO = "L",
}
